// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__zcHyd","filled":"Icon_filled__WPl7e","root":"Icon_root__160pf","solid":"Icon_solid__ZX5UU"};